import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Comment from '../../../Icons/24x24/Comment';
import ThreadStack from '../../_partials/ThreadStack';
import ThreadPostbox from '../../_partials/ThreadPostbox';
import LoadingIndicator from '../../../LoadingIndicator';
import Button from '../../../Button';
import { BiEventType } from '../../../biLogger/constants';
import ThreadHeader from '../../_partials/ThreadHeader';
import s from './FeedCardThread.scss';
var POSTFEED_MIN_COMMENT_COUNT_TO_SHOW_BOTTOM_POST = 5;
var FeedCardThread = function (_a) {
    var commentableItemId = _a.commentableItemId, commentableTypeId = _a.commentableTypeId, parentId = _a.parentId, allowSelfInit = _a.allowSelfInit, _b = _a.pageSize, pageSize = _b === void 0 ? 5 : _b, hasMore = _a.hasMore, isFetching = _a.isFetching, itemCount = _a.itemCount, fetchMore = _a.fetchMore, streamId = _a.streamId, className = _a.className, statsAndControls = _a.statsAndControls, extraInHeader = _a.extraInHeader, numberOfItemsShown = _a.numberOfItemsShown, isThreadOpen = _a.isThreadOpen, onShowMore = _a.onShowMore, onShowThread = _a.onShowThread, addNotification = _a.addNotification, showComments = _a.showComments;
    var t = useTranslation().t;
    var _c = useState(0), numberOfCommentsPosted = _c[0], setNumberOfCommentsPosted = _c[1];
    var isBottomPostboxVisible = itemCount >= POSTFEED_MIN_COMMENT_COUNT_TO_SHOW_BOTTOM_POST;
    var totalNumebrofItemsShown = numberOfItemsShown + numberOfCommentsPosted;
    var canFetchMore = totalNumebrofItemsShown + pageSize >= itemCount && hasMore;
    var onPublishSuccess = function () {
        setNumberOfCommentsPosted(function (posts) { return posts + 1; });
        showComments && showComments(streamId);
        onShowMore();
    };
    useEffect(function () {
        if (isThreadOpen && canFetchMore) {
            fetchMore(streamId);
        }
    }, [canFetchMore, streamId, fetchMore, isThreadOpen]);
    return (React.createElement("div", { className: className },
        React.createElement(ThreadPostbox, { className: s['commentbox'], commentableItemId: commentableItemId, commentableTypeId: commentableTypeId, parentId: parentId, position: "topmost", isSmall: true, onPublishSuccess: onPublishSuccess }),
        isThreadOpen && (React.createElement(React.Fragment, null,
            React.createElement(ThreadHeader, { className: s['header'], commentableItemId: commentableItemId, commentableTypeId: commentableTypeId, parentId: parentId, withOrder: ['on', 'order'].includes(statsAndControls), withTitle: ['on', 'title'].includes(statsAndControls) }, extraInHeader),
            React.createElement(ThreadStack, { className: s['thread-stack'], commentableItemId: commentableItemId, commentableTypeId: commentableTypeId, parentId: parentId, maxCommentsShown: totalNumebrofItemsShown, allowSelfInit: allowSelfInit }))),
        isFetching && React.createElement(LoadingIndicator, { view: "llama" }),
        isBottomPostboxVisible && (React.createElement(ThreadPostbox, { className: s['commentbox'], commentableItemId: commentableItemId, commentableTypeId: commentableTypeId, parentId: parentId, position: "bottom", isSmall: true, onPublishSuccess: function () {
                addNotification({
                    message: t('comment.info.posted'),
                    cardProps: { iconComponent: Comment },
                });
                onPublishSuccess();
            } })),
        isThreadOpen &&
            (totalNumebrofItemsShown < itemCount ||
                (totalNumebrofItemsShown >= itemCount && hasMore)) && (React.createElement(Button, { className: s['load-more'], view: "b33", onClick: onShowMore, biData: {
                evid: BiEventType.LOAD_MORE_COMMENTS_CLICK,
                itemid: commentableItemId,
                typeid: commentableTypeId,
            }, disabled: isFetching }, t('commentthread.control.viewmore'))),
        !isThreadOpen && (canFetchMore || itemCount > 0) && (React.createElement(Button, { className: s['load-more'], view: "b33", onClick: function () {
                onShowThread();
                onShowMore();
            }, biData: {
                evid: BiEventType.LOAD_MORE_COMMENTS_CLICK,
                itemid: commentableItemId,
                typeid: commentableTypeId,
            }, disabled: isFetching }, t('commentthread.control.viewcomments')))));
};
FeedCardThread.displayName = 'FeedCardThread';
export default FeedCardThread;
//# sourceMappingURL=FeedCardThread.js.map